import React, { useEffect, useRef } from "react";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import { useDispatch, useSelector } from "react-redux";
import { setProduct } from "../../store/actions";
import { useHistory } from "react-router";
import { useState } from "react";
import ClaimModal from "./ClaimModal";

const PromotionMessage = () => {
  const language = useSelector((state) => state.store.language);
  const dispatch = useDispatch();
  const history = useHistory();

  const storeCategories = useSelector((state) => state.store.store.categories);
  const freeProducts = useSelector((state) => state.cart.discounts.products);
  const freeProductsLength = useSelector((state) =>
    state.cart.discounts.products.reduce(
      (currentValue, freeProduct) => freeProduct["quantity"] + currentValue,
      0
    )
  );

  const categoryFreeProducts = useSelector(
    (state) => state.cart.discounts.category_free
  );
  const categoryFreeProductsLength = useSelector((state) =>
    state.cart.discounts.category_free.reduce(
      (currentValue, freeProduct) => freeProduct["quantity"] + currentValue,
      0
    )
  );
  const [open, setOpen] = useState(false);

  const [previousCategoryLength, setPreviousCategoryLength] = useState(0);
  const [previousProductLength, setPreviousProductLength] = useState(0);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const hasIncreased =
      categoryFreeProductsLength > previousCategoryLength ||
      freeProductsLength > previousProductLength;

    if (hasIncreased) {
      setOpen(true);
    }
    setPreviousCategoryLength(categoryFreeProductsLength);
    setPreviousProductLength(freeProductsLength);
  }, [categoryFreeProductsLength, freeProductsLength]);

  const message = () => {
    if (language === "english") {
      return (
        <span
          style={{
            textDecoration: "underline",
          }}
        >
          Claim your free products now!{" "}
        </span>
      );
    } else {
      return (
        <span
          style={{
            textDecoration: "underline",
          }}
        >
          احصل على منتجاتك المجانية الآن
        </span>
      );
    }
  };
  const handleDialogClaimItems = () => {
    const pendingProducts = freeProducts.filter((p) => p.quantity > 0);
    const pendingCategories = categoryFreeProducts.filter(
      (c) => c.quantity > 0
    );
    if (pendingProducts.length) {
      dispatch(setProduct());

      history.replace(
        `/product/${pendingProducts[0].category}/${
          pendingProducts[0].parent ? pendingProducts[0].parent + "/" : ""
        }${pendingProducts[0].slug}`,
        {
          pending_items: pendingProducts.slice(1),
          returnURL: "/checkout/confirmation",
        }
      );
    } else if (pendingCategories.length) {
      setShowModal(true);
    }
    setOpen(false);
  };
  return (
    <div>
      <Snackbar
        open={open}
        style={{
          cursor: "pointer",
        }}
        autoHideDuration={60000}
        onClose={(e, reason) => {
          if (reason !== "clickaway") {
            setOpen(false);
          }
        }}
        classes={{ anchorOriginBottomCenter: "snackbar-bottom-70" }}
      >
        <Alert onClose={() => setOpen(false)} severity="success">
          <span
            onClick={handleDialogClaimItems}
            style={{
              direction: language === "english" ? "ltr" : "rtl",
            }}
          >
            {message()}
          </span>
        </Alert>
      </Snackbar>
      <ClaimModal open={showModal} onClose={() => setShowModal(false)} />
    </div>
  );
};

export default PromotionMessage;